import React, { useEffect, useState } from "react";
import {
  Badge,
  Button,
  Card,
  Col,
  Container,
  FloatingLabel,
  Form,
  Modal,
  Row,
  Spinner,
  Table,
} from "react-bootstrap";
import { projectFirestore } from "../firebase/config";
import courses_data from "./../EE_courses.json";
import StudentsInfo from "../pages/home/StudentsInfo";
import { useFirestore } from "../hooks/useFirestore";
import { toast } from "react-toastify";


export default function ModalView({ student, setStudents }) {
  const [currentStudentId, setCurrentStudentId] = useState("");
  const [currentStudent, setCurrentStudent] = useState([]);
  const [studentCourses, setStudentCourses] = useState();
  const [status, setStatus] = useState([]);
  const { updateDocument } = useFirestore("students");
  const [rejectionReasonModal, setRejectionReaosonModal] = useState(false);
  const [acceptanceReasonModal, setAcceptanceReasonModal] = useState(false);
  const [units, setUnits] = useState([]);
  const [rejectionReason, setRejectionReaoson] = useState("");
  const [student_id, setStudentId] = useState('')
  const handleShow = () => setCurrentStudentId(student);

  const handleRejection = () => {
    setRejectionReaosonModal(true);
  };

  const handleAcceptance = () => {
     setAcceptanceReasonModal(true)
  }


  const fetchStudent = () => {
      // Query the "students" collection for documents where "name" is "John"
      const query = projectFirestore.collection("students").where("student_id", "==", currentStudentId);

      query.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const updatedStudent = doc.data();
          setCurrentStudent(updatedStudent);
          setStudentId(doc.id)
           
        });
      })
      .catch((error) => {
        console.log("Error getting documents: ", error);
      });
  }

  const handleStudentSubmission = (id, status, index) => {
    let isApproved;
    if (status === "approve") {
      isApproved = "Approved";
      const data = {
        status: isApproved,
        rejectionReason: rejectionReason,
      } 

      updateDocument(id, data);
      setAcceptanceReasonModal(false);

      // Update the status array using the index
      setStatus((prevStatus) => {
        const newStatus = [...prevStatus];
        newStatus[index] = isApproved;
        return newStatus;
      });
    } else if (status === "reject") {
      isApproved = "Rejected";

      const data = {
        status: isApproved,
        rejectionReason,
      };

      updateDocument(id, data);
      setRejectionReaosonModal(false);

      // Update the status array using the index
      setStatus((prevStatus) => {
        const newStatus = [...prevStatus];
        newStatus[index] = isApproved;
        return newStatus;
      });
    } else {
      isApproved = "Pending";
      const data = {
        status: isApproved,
      };
      updateDocument(id, data);

      // Update the status array using the index
      setStatus((prevStatus) => {
        const newStatus = [...prevStatus];
        newStatus[index] = isApproved;
        return newStatus;
      });
    }
    // Update the status of the corresponding student in the students array
    fetchStudent();
  };

   useEffect(() => {
      if(currentStudent.status === "Approved"){
        toast('تم القبول', {
          position: "top-center",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          type: "success"
          });
      }
   }, [currentStudent.status])

  const getCoursesByStudent = async () => {
    const student_Courses = [];
    const units = [];

        const courses = [];

        if (currentStudent?.new_subjects) {
          for (const courseId of currentStudent.new_subjects) {
            const course = courses_data.find(
              (doc) => doc.course_id === courseId
            );
            if (course) {
              courses.push(course);
              units.push(course.units);
            }
          }

          student_Courses.push({
            studentId: student.student_id,
            courses: courses,
          });
        }
  
    
    let sum = units.reduce((total, num) => total + num, 0);

    setStudentCourses(student_Courses);
    setUnits(sum);
  };

  useEffect(() => {
    getCoursesByStudent();
  }, [currentStudent]);

  useEffect(() => {
    if (currentStudentId) {
      fetchStudent();
    }
  }, [currentStudentId, status]);

  const handleDeleteSubject = async (subjectId) => {
    // Remove the subject from the currentStudent's subjects
    const updatedSubjects = currentStudent.new_subjects.filter(subject => subject !== subjectId);
    const updatedStudent = { ...currentStudent, new_subjects: updatedSubjects };

    // Update the student data in Firestore
    await updateDocument(student_id, updatedStudent);

    // Update local state
    setCurrentStudent(updatedStudent);
    fetchStudent(); // Refetch the student data
  };

  return (
    <>
      <a href="#" onClick={handleShow}>
        عرض تفاصيل الطلب
      </a>
      {/* <!-- Modal --> */}

      <Modal
        size="xl"
        show={currentStudentId === student}
        dialogClassName="modal-90w"
        onHide={() => setCurrentStudentId("")}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header className="btn-close-white" closeButton>
          <Modal.Title className="btn-close-white" id="example-modal-sizes-title-xl">
            بيانات الطالب : {currentStudentId}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="show-grid">
          <Container>
            {!studentCourses?.length && (
              <div
                style={{
                  display: "flex",
                  padding: "10rem",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                <Spinner animation="border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
              </div>
            )}

            {studentCourses?.length && studentCourses[0].courses && (
              <Row>
                <Col xs={12} sm={12} md={6}>
                  <h3> مقررات المسجلة </h3>
                  <h6>
                    {" "}
                    الحالة :{" "}
                    {
  currentStudent?.status === "Approved" ?  
    <Badge bg="success"> مقبول </Badge> : 
    (currentStudent?.status === "Rejected" ?  
      <Badge bg="danger"> مرفوض </Badge> : 
      (currentStudent?.new_subjects && currentStudent?.status === "Pending" ? 
        <Badge bg="primary"> في انتظار موافقة المشرف </Badge> :
        <Badge text="dark" bg="warning"> قيد التسجيل </Badge> ))
}

                  </h6>
                  <Table variant="dark" striped bordered hover size="sm">
                    <thead>
                      <tr>
                        <th> رمز المقرر </th>
                        <th> المقرر </th>

                        <th> units </th>

                        <th> pre </th>
                        <th> co </th>
                      </tr>
                    </thead>
                    <tbody>
                      {studentCourses?.length < 0 && (
                        <tr>
                          <td>لا يوجد</td>
                          <td>لا يوجد</td>
                          <td>لا يوجد</td>
                          <td>لا يوجد</td>
                          <td>لا يوجد</td>
                        </tr>
                      )}
                      {studentCourses?.length &&
                        studentCourses[0].courses?.map((course) => (
                          <tr key={course.course_id}>
                            <td>{course.course_id}</td>
                            <td>{course.course_title}</td>
                            <td>{course.units}</td>
                            <td>{course?.prerequisite?.join(" ,")}</td>
                            <td>{course?.corequisite?.join(" , ")}</td>
                            {/* <td>
                  <Button className="w-100" onClick={() => handleDeleteSubject(course.course_id)} size="sm" variant="danger"> 
                    <MdDeleteForever/>  
                </Button>
                </td> */}

                          </tr>
                        ))}
                      <tr>
                        <td colSpan={2}>
                          {" "}
                          <strong> مجموع الوحدات </strong>{" "}
                        </td>
                        <td colSpan={3}> {units} </td>
                      </tr>
                    </tbody>
                  </Table>

                  <Card className="comment-card">
                    <Card.Header> ملاحظات من الطالب </Card.Header>
                    <Card.Body>
                      {currentStudent?.notesToSupervisor ? (
                        `"${currentStudent?.notesToSupervisor}"`
                      ) : (
                        <strong> لا يوجد </strong>
                      )}
                    </Card.Body>
                  </Card>
                  <br />
                  <Card className="comment-card">
                    <Card.Header> ملاحظات المرشد </Card.Header>
                    <Card.Body>
                      {currentStudent?.rejectionReason ? (
                        `"${currentStudent?.rejectionReason}"`
                      ) : (
                        <strong> لا يوجد </strong>
                      )}
                    </Card.Body>
                  </Card>
                </Col>
                <Col style={{ margin: "auto" }} xs={12} md={6}>
                  <StudentsInfo students={currentStudent} />
                </Col>
              </Row>
            )}
          </Container>
        </Modal.Body>
        <Modal.Footer style={{ display: "flex", justifyContent: "flex-start" }}>
          <Button
            onClick={handleAcceptance}
            style={{ width: "10rem" }}
            variant="success"
            disabled={currentStudent?.new_subjects?.length === 0 || currentStudent.status === "Approved"}
          >
            قبول
          </Button>
          <Button
            onClick={handleRejection}
            style={{ width: "10rem" }}
            variant="danger"
          >
            رفض
          </Button>
       
        </Modal.Footer>
      </Modal>

      <Modal
        className="comment-modal"
        show={acceptanceReasonModal}
        onHide={() => setAcceptanceReasonModal(false)}
      >
        <Modal.Header>
          <Modal.Title>  ملاحظات للطالب </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FloatingLabel
            controlId="floatingTextarea"
            label="اترك تعليق هنا"
            className="mb-3"
          >
            <Form.Control
              onChange={(e) => setRejectionReaoson(e.target.value)}
              as="textarea"
              placeholder="يرجي ادخال تعليق هنا"
            />
          </FloatingLabel>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setAcceptanceReasonModal(false)}
          >
            إلغاء
          </Button>
          <Button
            variant="light"
            onClick={() => handleStudentSubmission(student_id, "approve")}
          >
            ارسال
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        className="comment-modal"
        show={rejectionReasonModal}
        onHide={() => setRejectionReaosonModal(false)}
      >
        <Modal.Header>
          <Modal.Title>  يرجى إدخال سبب الرفض</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FloatingLabel
            controlId="floatingTextarea"
            label="اترك تعليق هنا"
            className="mb-3"
          >
            <Form.Control
              onChange={(e) => setRejectionReaoson(e.target.value)}
              as="textarea"
              placeholder="يرجي ادخال تعليق هنا"
            />
          </FloatingLabel>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setRejectionReaosonModal(false)}
          >
            إلغاء
          </Button>
          <Button
            variant="light"
            onClick={() => handleStudentSubmission(student_id, "reject")}
          >
            ارسال
          </Button>
        </Modal.Footer>
      </Modal>
      
    </>
  );
}
